import { Stack, styled, Theme } from '@mui/material';
import LabelBottomNavigation from '../BottomNavigation/BottomNavigation';
import { isBrowser } from 'react-device-detect';
import { useKeyboardOpen } from '../../../hooks/useKeyboardOpen';

const StyledFooter = styled('footer')(() => ({
  position: 'fixed',
  bottom: 0,
  right: 0,
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  zIndex: 100
}));

export const Footer = () => {
  const isKeyboardOpen = useKeyboardOpen();

  if (isKeyboardOpen) return null;

  return (
    <StyledFooter>
      <Stack
        direction="row"
        sx={(theme: Theme) => ({
          position: 'relative',
          maxWidth: !isBrowser ? '100%' : '400px',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          backgroundColor: theme.palette.gray[300],
        })}
      >
        <LabelBottomNavigation />
      </Stack>
    </StyledFooter>
  );
};
